import { Post } from '@/types/post';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';

const CATEGORY_COLORS: Record<string, string> = {
  'Global Affairs': 'bg-teal-50 text-teal-700 border-teal-100',
  'International Order': 'bg-stone-100 text-stone-700 border-stone-200',
  'Rights and Freedoms': 'bg-rose-50 text-rose-700 border-rose-100',
  'Politics': 'bg-amber-50 text-amber-700 border-amber-100',
  'Justice and Freedom': 'bg-neutral-100 text-neutral-700 border-neutral-200',
  'Law and Society': 'bg-stone-100 text-stone-600 border-stone-200',
};

interface PostCardProps {
  post: Post;
}

const PostCard = ({ post }: PostCardProps) => {
  const { lang, t } = useLanguage();
  const categoryColor = CATEGORY_COLORS[post.category] || 'bg-stone-100 text-stone-600 border-stone-200';

  return (
    <Link
      to={`/issues/${post.slug}`}
      className="group cursor-pointer bg-white border border-stone-100 rounded-xl overflow-hidden hover:border-stone-200 transition-all duration-300 block"
    >
      <div className="aspect-[4/3] overflow-hidden bg-stone-100">
        <img
          src={post.coverImage}
          alt={post.title[lang]}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${categoryColor}`}>
            {post.category}
          </span>
          <span className="text-xs text-stone-400">{post.readTime} min read</span>
        </div>
        <h3 className="text-sm font-bold text-stone-800 leading-snug mb-1 line-clamp-2 group-hover:text-stone-600 transition-colors">
          {post.title[lang]}
        </h3>
        <p className="text-xs text-stone-500 line-clamp-2 leading-relaxed">{post.summary[lang]}</p>
        <div className="flex items-center gap-3 mt-3 pt-3 border-t border-stone-50">
          <span className="text-xs text-stone-400">{post.date}</span>
          <div className="flex items-center gap-1 ml-auto">
            <span className="text-sm">❤️</span>
            <span className="text-xs text-stone-400">{post.emojiReactions['❤️']}</span>
            <span className="text-sm ml-1">💬</span>
            <span className="text-xs text-stone-400">{post.comments.filter(c => !c.blocked).length}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;